export default function AuthModal() {
  return null;
}